
import { validationMixin } from 'vuelidate';
import { required, minValue } from 'vuelidate/lib/validators';
import { DateType, getCustomerTypeNo } from '../../util/Enum';
import util from '../../util/Util';

export default {
  mixins: [validationMixin],
  props: {
    modalShow: {
      type: Boolean,
      default: false
    },
    selectedQuote: {
      type: Object,
      default: null
    },
    load: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isModalVisible: false,
      quote: {
        loadId: null,
        shipperUserId: null,
        carrierUserId: null, 
        amount: null,
        isExclusiveGST: false,
        totalAmount: null,
        collectionDate: null,
        deliveryDate: null,
        serviceLevel: null,
        referenceNumber: null,
        terms: null,
        other: null,
        carrierUserIdentifier: null
      },
      collectionAndDeviveryOptions: [
        { value: 1, text: 'Within 1 weeks of booking' },
        { value: 2, text: 'Within 2 weeks of booking' },
        { value: 3, text: 'On a specified date' },
        { value: 4, text: 'Date Range' },
        { value: 5, text: 'As per quote specific terms' }
      ],
      invalidFeedback: 'This is a required field.',
      DateType,
      isdisabled: false,
      util
    };
  },
  validations: {
    quote: {
      amount: {
        required,
        minValue: minValue(0.01),
        valid(value) {
          return util.validateTwoDecimalPoint(value)
        }
      },
      collectionDate: {
        required
      },
      deliveryDate: {
        required
      },
      serviceLevel: {
        required
      },
      terms: {
        required
      }
    }
  },
  computed:{
    user() {

      return this.$store.state.user;
    }
  },
  created() {
    this.isModalVisible = this.modalShow
    if (this.selectedQuote) {
      this.quote = { ...this.selectedQuote }
    }

  },
  beforeMount() {
    window.addEventListener('beforeunload', this.preventNav)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.preventNav);
  },
  methods: {
    preventNav(event) {
      // if (this.isButtonDisabled) return
        event.preventDefault()
        event.returnValue = ''
    },
    getLoadDateTypeClass(type) {
      switch (type) {
        case DateType.READY_TO_GO:
          return 'date-time delivered';
        case DateType.SET_DATE_RANGE:
          return 'date-time pending';
        case DateType.NO_SET_DATE:
          return 'date-time no-date';
      }
    },
    validateDetailsState(name) {
      const { $dirty, $error } = this.$v.quote[name];
      return $dirty ? !$error : null;
    },
    // close modal
    close() {
      this.$emit('close');
    },
    totalAmountCal() {
      const total = this.quote.isExclusiveGST ?  (parseFloat(this.quote.amount) + (parseFloat(this.quote.amount)*10/100) ) :  parseFloat(this.quote.amount)
      this.quote.totalAmount = util.formatNumberTwoDecimal(total)
    },
    dateDisabled(ymd, date) {
      let today = new Date();
      let yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      if (date.setHours(0, 0, 0, 0) <= yesterday.setHours(0, 0, 0, 0)) {
        return true;
      }
      return false;
    },
    submitQuote(event) {
      event.preventDefault()
      this.$v.quote.$touch();
      if (this.$v.quote.$anyError) {
        return;
      } else {
        this.isdisabled = true
        this.quote.loadId = this.load.id
        this.quote.shipperUserId = this.load.userId
        this.quote.carrierUserId = this.user.currentUser.id
        this.quote.amount = parseFloat(this.quote.amount)
        this.quote.totalAmount = parseFloat(this.quote.totalAmount)
        this.quote.carrierUserIdentifier = this.user.currentUser.userIdentifier
        this.quote.carrierCustomerType = getCustomerTypeNo(this.user.currentUser.type)
        const payload = {
          data: this.quote,
          user: this.user
        }

        // this.$emit('go-next', this.portableItem)
        this.$store.dispatch('quote/subimtQuote', payload).then((res) => {
          if (res.isSuccess) {
            if (this.selectedQuote) {
              this.$toast.success('Quote Successfully Updated').goAway(3000)
            } else {
              this.$toast.success('Quote Successfully Created').goAway(3000)
            }
          } else {
            this.$toast.error('Failed to Create Quote - Contact support@utransport.com.au').goAway(5000)
          }
          this.$emit('submit-close');
          this.isdisabled = false
      })
      }
    }
  }
}
